import React from 'react';

/**
 * APM (Application Performance Monitoring) Help Content
 */
const APMHelp: React.FC = () => {
  return (
    <>
      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Application Performance Monitoring
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          APM provides deep visibility into your agent infrastructure health. Monitor CPU, memory, and thread metrics to ensure optimal performance.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Health Score
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed mb-3">
          The health score aggregates multiple metrics into a single indicator:
        </p>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium text-green-600 dark:text-green-400">90-100%</span>: Excellent - All systems operating normally</p>
          <p>&#8226; <span className="font-medium text-yellow-600 dark:text-yellow-400">70-89%</span>: Good - Minor issues detected</p>
          <p>&#8226; <span className="font-medium text-orange-600 dark:text-orange-400">50-69%</span>: Warning - Performance degradation</p>
          <p>&#8226; <span className="font-medium text-red-600 dark:text-red-400">0-49%</span>: Critical - Immediate attention needed</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Key Metrics
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; <span className="font-medium">CPU Usage</span>: Processor utilization percentage</p>
          <p>&#8226; <span className="font-medium">Memory Usage</span>: RAM consumption and trends</p>
          <p>&#8226; <span className="font-medium">Thread Count</span>: Active threads</p>
          <p>&#8226; <span className="font-medium">Response Time</span>: Service latency trends</p>
        </div>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Alerts
        </h3>
        <p className="text-sm text-gray-600 dark:text-gray-400 leading-relaxed">
          Configure alerts for critical thresholds. Receive notifications when CPU exceeds 80% or memory usage is high.
        </p>
      </div>

      <div>
        <h3 className="text-base font-semibold text-gray-900 dark:text-white mb-2">
          Troubleshooting
        </h3>
        <div className="space-y-2 text-sm text-gray-600 dark:text-gray-400">
          <p>&#8226; High CPU: Check for inefficient loops or heavy computations</p>
          <p>&#8226; Memory growth: Look for memory leaks in long-running agents</p>
        </div>
      </div>

    </>
  );
};

export default APMHelp;
